import type { NormalizedBarChartData } from './types';

export interface SeriesSignSummary {
  hasPositive: boolean;
  hasNegative: boolean;
}

/** Type-narrowing predicate: true for non-NaN, non-Infinity numbers. */
export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

/** Type-narrowing predicate: true for strings with at least one non-whitespace char. */
export const isNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

/**
 * Reports whether the dataset contains any non-negative or any negative
 * renderable values. Zero counts as positive. Null values are ignored.
 */
export const getSeriesSignSummary = (
  series: NormalizedBarChartData['series']
): SeriesSignSummary => {
  let hasPositive = false;
  let hasNegative = false;

  for (const singleSeries of series) {
    for (const value of singleSeries.values) {
      if (value === null) continue;
      if (value < 0) {
        hasNegative = true;
      } else {
        hasPositive = true;
      }
      if (hasPositive && hasNegative) {
        return { hasPositive, hasNegative };
      }
    }
  }

  return { hasPositive, hasNegative };
};
